import Panel from '../components/common/Panel';

export default function PrivacyPage() {
  return (
    <div className="page-enter min-h-screen" style={{ background: 'var(--bg-primary)' }}>
      <div className="max-w-[800px] mx-auto px-4 py-8 md:py-12">
        <h1 className="font-display text-3xl mb-2" style={{ color: 'var(--text-primary)' }}>
          Privacy Policy
        </h1>
        <p className="text-sm mb-8" style={{ color: 'var(--text-muted)' }}>
          Effective Date: March 27, 2026
        </p>

        <div className="space-y-6">
          <Panel title="1. Data Collection">
            <div className="text-sm leading-relaxed space-y-3" style={{ color: 'var(--text-secondary)' }}>
              <p>
                Netrun Systems ("Company", "we", "us") collects the following types of information
                when you use KOG ("the Service"):
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong style={{ color: 'var(--text-primary)' }}>Account information:</strong> name, email address, username, and password</li>
                <li><strong style={{ color: 'var(--text-primary)' }}>CRM data:</strong> contacts, organizations, activities, deals, and documents you create</li>
                <li><strong style={{ color: 'var(--text-primary)' }}>Usage data:</strong> log data, device information, IP address, and browser type</li>
                <li><strong style={{ color: 'var(--text-primary)' }}>Billing data:</strong> payment method details processed securely through Stripe</li>
              </ul>
            </div>
          </Panel>

          <Panel title="2. Use of Data">
            <div className="text-sm leading-relaxed space-y-3" style={{ color: 'var(--text-secondary)' }}>
              <p>We use collected data to:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Provide, maintain, and improve the Service</li>
                <li>Authenticate users and protect account security</li>
                <li>Process billing and subscription management</li>
                <li>Provide AI-powered insights and recommendations</li>
                <li>Send service-related notifications and updates</li>
                <li>Monitor and analyze usage patterns to improve user experience</li>
              </ul>
            </div>
          </Panel>

          <Panel title="3. Data Sharing">
            <div className="text-sm leading-relaxed space-y-3" style={{ color: 'var(--text-secondary)' }}>
              <p>
                We do not sell your personal data. We may share data with:
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong style={{ color: 'var(--text-primary)' }}>Service providers:</strong> Google Cloud (hosting), Stripe (payments), and other vendors necessary to operate the Service</li>
                <li><strong style={{ color: 'var(--text-primary)' }}>AI providers:</strong> Anonymized or aggregated data may be sent to AI services (Google Gemini) to power features</li>
                <li><strong style={{ color: 'var(--text-primary)' }}>Legal requirements:</strong> When required by law, regulation, or legal process</li>
              </ul>
            </div>
          </Panel>

          <Panel title="4. Cookies & Tracking">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              The Service uses local storage (not cookies) to store authentication tokens for session
              management. We do not use third-party advertising trackers. Basic analytics may be used
              to understand usage patterns and improve the Service.
            </p>
          </Panel>

          <Panel title="5. Data Retention">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              We retain your data for as long as your account is active or as needed to provide the
              Service. Upon account deletion, your data will be permanently removed within 90 days,
              except where retention is required by law. You may request immediate deletion by
              contacting us.
            </p>
          </Panel>

          <Panel title="6. Your Rights (GDPR / CCPA)">
            <div className="text-sm leading-relaxed space-y-3" style={{ color: 'var(--text-secondary)' }}>
              <p>You have the right to:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong style={{ color: 'var(--text-primary)' }}>Access:</strong> Request a copy of your personal data</li>
                <li><strong style={{ color: 'var(--text-primary)' }}>Rectification:</strong> Request correction of inaccurate data</li>
                <li><strong style={{ color: 'var(--text-primary)' }}>Erasure:</strong> Request deletion of your data</li>
                <li><strong style={{ color: 'var(--text-primary)' }}>Portability:</strong> Request export of your data in a machine-readable format</li>
                <li><strong style={{ color: 'var(--text-primary)' }}>Objection:</strong> Object to processing of your data</li>
                <li><strong style={{ color: 'var(--text-primary)' }}>Restriction:</strong> Request restriction of processing</li>
              </ul>
              <p>
                To exercise any of these rights, contact us at the address below.
              </p>
            </div>
          </Panel>

          <Panel title="7. Security">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              We implement industry-standard security measures including encryption in transit (TLS),
              encryption at rest, JWT-based authentication, and role-based access control. While we
              strive to protect your data, no method of electronic transmission or storage is 100%
              secure.
            </p>
          </Panel>

          <Panel title="8. Contact">
            <div className="text-sm leading-relaxed space-y-2" style={{ color: 'var(--text-secondary)' }}>
              <p>
                For privacy-related inquiries, contact:
              </p>
              <p>
                <a href="mailto:privacy@netrunsystems.com" style={{ color: 'var(--netrun-green)' }}>
                  privacy@netrunsystems.com
                </a>
              </p>
              <p>Netrun Systems &middot; California, USA</p>
            </div>
          </Panel>
        </div>

        <p className="text-xs mt-8 text-center" style={{ color: 'var(--text-muted)' }}>
          Netrun Systems &middot; California, USA
        </p>
      </div>
    </div>
  );
}
